import { cloneDeep, get, set } from 'lodash';

import {
  FIELD_PATHS,
  FIELD_VALUES,
  LIABILITY_TYPE,
  PRODUCT_PREFERENCE_FIELD_PATHS,
  REFINANCING_REASONS,
} from '@funnels/constants';
import { FormValuesProductPreference, Liability } from '@funnels/types';

import { INITIAL_PRODUCT_PREFERENCE_REFINANCE_REASON } from './initialFormValues';

export const setRefinanceReasonInitialValues = (formValues: FormValuesProductPreference) => {
  const initializedFormValues = cloneDeep(formValues);
  const currentRefinanceReasons = get(
    initializedFormValues,
    PRODUCT_PREFERENCE_FIELD_PATHS.PRODUCT_PREFERENCE_REFINANCE_REASONS(0),
    []
  );
  // set default value when user first time lading this page
  if (currentRefinanceReasons.length === 0) {
    const initialRefinanceReasons = [];
    const hasDecreaseRepayments =
      get(initializedFormValues, FIELD_PATHS.APPLICATION_REFINANCING_REASON(0, 0)) === FIELD_VALUES.DECREASE_REPAYMENTS;

    const hasFasterPayOff =
      get(initializedFormValues, FIELD_PATHS.APPLICATION_REFINANCING_REASON(0, 0)) === FIELD_VALUES.FASTER_PAYOFF;

    const hasIncreaseLoanAmount = !!get(initializedFormValues, FIELD_PATHS.APPLICATION_CASHOUT_AMOUNT(0));

    const liabilities: Liability[] = get(initializedFormValues, FIELD_PATHS.LIABILITIES(), []);
    const hasClearingFromThisLoan = liabilities.some(
      (liability: Liability) =>
        get({ liabilities: [liability] }, FIELD_PATHS.LIABILITY_CLEARING_FROM_THIS_LOAN(0)) === true &&
        get({ liabilities: [liability] }, FIELD_PATHS.LIABILITY_TYPE(0)) !== LIABILITY_TYPE.HOME_LOAN
    );

    if (hasDecreaseRepayments) {
      initialRefinanceReasons.push(INITIAL_PRODUCT_PREFERENCE_REFINANCE_REASON(REFINANCING_REASONS.DecreaseRepayments));
    }
    if (hasFasterPayOff) {
      initialRefinanceReasons.push(
        INITIAL_PRODUCT_PREFERENCE_REFINANCE_REASON(REFINANCING_REASONS.PayOffLoanFasterWithALowerInterestRate)
      );
    }
    if (hasIncreaseLoanAmount) {
      initialRefinanceReasons.push(INITIAL_PRODUCT_PREFERENCE_REFINANCE_REASON(REFINANCING_REASONS.IncreaseLoanAmount));
    }
    if (hasClearingFromThisLoan) {
      initialRefinanceReasons.push(
        INITIAL_PRODUCT_PREFERENCE_REFINANCE_REASON(REFINANCING_REASONS.ConsolidateDebtAndReduceNumberOfLenders)
      );
    }
    set(initializedFormValues, FIELD_PATHS.PRODUCT_PREFERENCE_REFINANCE_REASONS(0), initialRefinanceReasons);
  }
  return initializedFormValues;
};
